import { cva, VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/shared/utils/cn';

const inputVariants = cva(
  'flex h-11 w-full rounded-xs border-[0.5px] border-white/50 bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-custom-light-grey focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      sizeOption: {
        default: 'h-11',
        small: 'h-9',
      },
      variant: {
        default: '',
        form: 'text-white',
        'form-alt': 'h-auto py-3 px-5 text-white',
        'search-bar': 'h-9 text-2xs placeholder:font-medium',
        dark: 'bg-light-container-alt border-none text-white text-2xs focus-visible:ring-0',
      },
    },
  },
);

export interface InputProps
  extends
    React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, variant, type, prefixIcon, suffixIcon, sizeOption, ...props },
    ref,
  ) => {
    return (
      <div className="relative w-full">
        {prefixIcon && (
          <div className="absolute left-2 top-1/2 -translate-y-1/2 transform">
            {prefixIcon}
          </div>
        )}
        <input
          type={type}
          className={cn(
            inputVariants({ variant: variant, sizeOption: sizeOption }),
            prefixIcon ? 'pl-8' : '',
            suffixIcon ? 'pr-8' : '',
            className,
          )}
          ref={ref}
          {...props}
        />
        {suffixIcon && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2 transform">
            {suffixIcon}
          </div>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
